<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1000"
    v-if="ticket"
  >
    <CreateCommentDialog
      :dialog="showCreateCommentDialog"
      :ticketId="ticket.id"
      :comments="ticket.comments"
      @close="closeCreateCommentDialog"
    >
    </CreateCommentDialog>

    <CreateAttachmentDialog
      :dialog="showCreateAttachmentDialog"
      :ticket="ticket"
      @close="closeCreateAttachmentDialog"
    >
    </CreateAttachmentDialog>

    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title v-if="!ticket.closed">
          Support Ticket - {{ticket.id}} - OPEN
        </v-toolbar-title>
        <v-toolbar-title v-else>
          Support Ticket - {{ticket.id}} - CLOSED
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="onCloseClick()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-tabs
          v-model="tab"
          align-with-title
          background-color="transparent"
          grow
        >
          <v-tabs-slider color="red"></v-tabs-slider>

          <v-tab>Ticket</v-tab>
          <v-tab>Attachments ({{ticket.attachments ? ticket.attachments.length : 0}})</v-tab>
        </v-tabs>

        <v-tabs-items
          v-model="tab"
        >
          <v-tab-item>
            <TicketTab ref="ticket" :ticket="ticket" />
          </v-tab-item>
          <v-tab-item>
            <AttachmentsTab ref="attachments" :ticket="ticket" />
          </v-tab-item>
        </v-tabs-items>

      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="amber"
          v-if="!ticket.closed"
          @click.stop="showCreateAttachmentDialog = true"
        >
          New Attachment
        </v-btn>
        <v-btn
          color="amber"
          v-if="!ticket.closed"
          @click.stop="showCreateCommentDialog = true"
        >
          New Comment
        </v-btn>
        <v-btn
          color="grey lighten-1"
          @click="onCloseClick()"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CreateCommentDialog from './CreateCommentDialog.vue';
import TicketTab from './TicketTab.vue';
import AttachmentsTab from './AttachmentsTab.vue';
import CreateAttachmentDialog from './CreateAttachmentDialog.vue';

export default {
  components: {
    CreateCommentDialog,
    TicketTab,
    AttachmentsTab,
    CreateAttachmentDialog,
  },

  props: {
    dialog: Boolean,
    ticket: Object,
  },

  data() {
    return {
      showCreateCommentDialog: false,
      showCreateAttachmentDialog: false,
      tab: 0,
    };
  },

  methods: {
    onCloseClick() {
      this.$emit('close');
    },

    closeCreateCommentDialog({ text }) {
      if (text !== null && text !== '') {
        const options = {
          method: 'post',
          url: '/create/comment/v1/',
          data: {
            ticketId: this.ticket.id,
            authorUsername: this.$store.state.auth.token.user.username,
            text,
          },
        };

        this.axios(options)
          .then((res) => {
            this.ticket.comments.push(res.data);
            this.showCreateCommentDialog = false;
          })
          .catch((err) => {
            this.showCreateCommentDialog = false;
          });
      } else {
        this.showCreateCommentDialog = false;
      }
    },

    closeCreateAttachmentDialog() {
      this.showCreateAttachmentDialog = false;
    },
  },
};
</script>
